module.exports = {
    STRING: 'string',
    NUMBER: 'number',
    DATE: 'date',
    BOOLEAN: 'boolean',
    REFERENCE: 'reference',
    OPERATOR: 'operator',
    TIME_UNIT: 'time-unit'
};
